/* Home only. Restore the launcher after scrolling settles; cart visibility is CSS-owned. */
(() => {
  let scrollTimer;
  window.addEventListener('scroll', () => {
    document.body.classList.add('cs-is-scrolling');
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      document.body.classList.remove('cs-is-scrolling');
    }, 1000);
  }, { passive: true });
})();
